"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.buildTransaction = void 0;
var util_1 = require("@polkadot/util");
var cache_1 = require("./cache");
var logic_1 = require("./logic");
var EXTRINSIC_VERSION = 4;
// Default values for tx parameters, if the user doesn't specify any
var DEFAULTS = {
    tip: 0,
    eraPeriod: 64
};
var getExtrinsicParams = function (a, t) {
    var _a;
    var validator = t.validators ? t.validators[0] : null;
    switch (t.mode) {
        case "send":
            // Construct a balance transfer transaction offline.
            return {
                args: {
                    dest: t.recipient,
                    value: t.amount.toString()
                },
                name: t.useAllAmount ? "transfer" : "transferKeepAlive",
                pallet: "balances"
            };
        case "bond":
            if ((0, logic_1.isFirstBond)(a)) {
                return {
                    pallet: "staking",
                    name: "bond",
                    args: {
                        // Spec choice: we always set the account as both the stash and its controller
                        controller: a.freshAddress,
                        value: t.amount.toString(),
                        // The rewards destination. Can be "Stash", "Staked", "Controller" or "{ Account: accountId }"".
                        payee: t.rewardDestination || "Stash"
                    }
                };
            }
            else {
                // Add some extra amount from the stash's `free_balance` into the staking balance.
                // Can only be called when `EraElectionStatus` is `Closed`.
                return {
                    pallet: "staking",
                    name: "bondExtra",
                    args: {
                        maxAdditional: t.amount.toString()
                    }
                };
            }
        case "unbond":
            // Construct a transaction to unbond funds from a Stash account.
            // Must be signed by the controller, and can be only called when `EraElectionStatus` is `Closed`.
            return {
                pallet: "staking",
                name: "unbond",
                args: {
                    value: t.amount.toString()
                }
            };
        case "rebond":
            // Rebond a portion of the stash scheduled to be unlocked.
            // Must be signed by the controller, and can be only called when `EraElectionStatus` is `Closed`.
            return {
                pallet: "staking",
                name: "rebond",
                args: {
                    value: t.amount.toString()
                }
            };
        case "withdrawUnbonded":
            // Remove any unbonded chunks from the `unbonding` queue from our management
            // Must be signed by the controller, and can be only called when `EraElectionStatus` is `Closed`.
            return {
                pallet: "staking",
                name: "withdrawUnbonded",
                args: {
                    numSlashingSpans: ((_a = a.polkadotResources) === null || _a === void 0 ? void 0 : _a.numSlashingSpans) || 0
                }
            };
        case "setController":
            // Set the current account as its own controller
            return {
                pallet: "staking",
                name: "setController",
                args: { controller: a.freshAddress }
            };
        case "nominate":
            // Construct a transaction to nominate validators.
            // Must be signed by the controller, and can be only called when `EraElectionStatus` is `Closed`.
            return {
                pallet: "staking",
                name: "nominate",
                args: {
                    targets: t.validators
                }
            };
        case "chill":
            // Declare the desire to cease validating or nominating. Does not unbond funds.
            // Must be signed by the controller, and can be only called when `EraElectionStatus` is `Closed`.
            return {
                pallet: "staking",
                name: "chill",
                args: {}
            };
        case "claimReward":
            // Pay out all the stakers behind a single validator for a single era.
            // Any account can call this function, even if it is not one of the stakers.
            // Can only be called when `EraElectionStatus` is `Closed`.
            return {
                pallet: "staking",
                name: "payoutStakers",
                args: {
                    validatorStash: validator,
                    era: t.era
                }
            };
        default:
            throw new Error("Unknown mode in transaction");
    }
};
/**
 *
 * @param {Account} a
 * @param {Transaction} t
 * @param {boolean} forceLatestParams - forces the use of latest transaction params
 */
var buildTransaction = function (a, t, forceLatestParams) {
    if (forceLatestParams === void 0) { forceLatestParams = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, extrinsics, registry, info, _b, extrinsicParams, address, blockHash, genesisHash, blockNumber, era, nonce, specVersion, tip, transactionVersion, methodFunction, methodArgs, method, unsigned;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, cache_1.getRegistry)()];
                case 1:
                    _a = _c.sent(), extrinsics = _a.extrinsics, registry = _a.registry;
                    if (!forceLatestParams) return [3 /*break*/, 3];
                    return [4 /*yield*/, cache_1.getTransactionParams.force()];
                case 2:
                    _b = _c.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, (0, cache_1.getTransactionParams)()];
                case 4:
                    _b = _c.sent();
                    _c.label = 5;
                case 5:
                    info = _b;
                    extrinsicParams = getExtrinsicParams(a, t);
                    address = a.freshAddress;
                    blockHash = info.blockHash, genesisHash = info.genesisHash;
                    blockNumber = registry
                        .createType("BlockNumber", info.blockNumber)
                        .toHex();
                    era = registry
                        .createType("ExtrinsicEra", {
                        current: info.blockNumber,
                        period: DEFAULTS.eraPeriod
                    })
                        .toHex();
                    nonce = registry.createType("Compact<Index>", (0, logic_1.getNonce)(a)).toHex();
                    specVersion = registry.createType("u32", info.specVersion).toHex();
                    tip = registry
                        .createType("Compact<Balance>", info.tip || DEFAULTS.tip)
                        .toHex();
                    transactionVersion = registry
                        .createType("u32", info.transactionVersion)
                        .toHex();
                    methodFunction = extrinsics[extrinsicParams.pallet][extrinsicParams.name];
                    methodArgs = methodFunction.meta.args;
                    method = methodFunction.apply(void 0, __spreadArray([], __read(methodArgs.map(function (arg) {
                        if (extrinsicParams.args[(0, util_1.stringCamelCase)(arg.name.toString())] === undefined) {
                            throw new Error("Method ".concat(extrinsicParams.pallet, "::").concat(extrinsicParams.name, " expects argument ").concat(arg.toString(), ", but got undefined"));
                        }
                        return extrinsicParams.args[(0, util_1.stringCamelCase)(arg.name.toString())];
                    })), false)).toHex();
                    unsigned = {
                        address: address,
                        blockHash: blockHash,
                        blockNumber: blockNumber,
                        era: era,
                        genesisHash: genesisHash,
                        method: method,
                        nonce: nonce,
                        signedExtensions: registry.signedExtensions,
                        specVersion: specVersion,
                        tip: tip,
                        transactionVersion: transactionVersion,
                        version: EXTRINSIC_VERSION
                    };
                    return [2 /*return*/, {
                            registry: registry,
                            unsigned: unsigned
                        }];
            }
        });
    });
};
exports.buildTransaction = buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map